import { render, staticRenderFns } from "./artifact-sidepanel.vue?vue&type=template&id=eed201f2&scoped=true"
import script from "./artifact-sidepanel.vue?vue&type=script&lang=js"
export * from "./artifact-sidepanel.vue?vue&type=script&lang=js"
import style0 from "./artifact-sidepanel.vue?vue&type=style&index=0&id=eed201f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eed201f2",
  null
  
)

export default component.exports